import css from 'styled-jsx/css';
import { serif, sansSerif } from 'styles/css-constants';
import { MQ_LARGE } from 'constants/mq';
import { warmGrays, sharedPalette } from 'styles/colors/constants';

export default css`
  .RecipeFirstRecipe {
    font-family: ${serif};
    margin: 2rem 0;
    border-bottom: 1px solid ${warmGrays[0]};
  }

  .RecipeFirstRecipe :global(a) {
    border-bottom: 1px solid currentColor;
    color: #000;
    display: inline-block;
  }

  .RecipeFirstRecipe__ingredientsSection {
    margin: 2rem 0;
  }

  .RecipeFirstRecipe__ingredientsHeading,
  .RecipeFirstRecipe__instructionsHeading,
  .RecipeFirstRecipe :global(.Recipe__suppliesGroupName) {
    font-family: ${sansSerif};
    font-size: var(--baseFontSize);
    font-weight: bold;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    margin-bottom: 1rem;
  }

  .Recipe__ingredientsGroups {
    margin-top: 1rem;
  }

  .Recipe__ingredients {
    list-style: none;
    padding-left: 0;
  }

  .RecipeFirstRecipe :global(.Recipe__ingredients),
  .RecipeFirstRecipe :global(.Recipe__supplies) {
    padding-left: 0;
    list-style: none;
    font-family: ${sansSerif};
    font-size: var(--baseFontSize);
  }

  .RecipeFirstRecipe :global(.Recipe__ingredient),
  .RecipeFirstRecipe :global(.Recipe__supplyItem) {
    position: relative;
    margin-bottom: 0.75rem;
    line-height: 1.35;
  }

  .RecipeFirstRecipe :global(.Recipe__instructions) {
    list-style: none;
    counter-reset: listCounter;
  }

  .RecipeFirstRecipe :global(.Recipe__instructionsGroup) {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  /* 
 * Because of a Recipe editor limitation we have to force
 * text to be inline 
 */
  .RecipeFirstRecipe :global(.Recipe__ingredient p),
  .RecipeFirstRecipe :global(.Recipe__ingredient span),
  .RecipeFirstRecipe :global(.Recipe__instructionsGroup p),
  .RecipeFirstRecipe :global(.Recipe__instructionsGroup span) {
    display: inline;
  }

  .RecipeFirstRecipe :global(.Recipe__instructionStep),
  .Recipe__notes {
    font-size: var(--fontScale1);
    line-height: 1.5;
  }

  .RecipeFirstRecipe :global(.Recipe__instructionStep) {
    position: relative;
    margin-top: 0.5rem;
    border-top: 1px solid ${warmGrays[1]};
    padding-top: 0.5rem;
  }

  .RecipeFirstRecipe :global(.Recipe__instructionStep a),
  .Recipe .Recipe__notes a {
    border-bottom: 1px solid currentColor;
    color: #000;
  }

  .RecipeFirstRecipe :global(.Recipe__instructionStep p),
  .RecipeFirstRecipe__notes :global(p) {
    font-family: ${serif};
    margin-bottom: 1em;
  }

  .RecipeFirstRecipe :global(.Recipe__instructionStep p) {
    margin-bottom: 0;
  }

  .RecipeFirstRecipe :global(.Recipe__instructionStep .Figure) {
    padding-top: 1rem;
    padding-bottom: 0.5rem;
  }

  .RecipeFirstRecipe :global(.Recipe__instructionStepContent) {
    margin-bottom: 0.5rem;
  }

  .RecipeFirstRecipe :global(.Recipe__instructionStepContent::before) {
    margin-right: 0.5rem;
    counter-increment: listCounter;
    content: counter(listCounter);
    display: inline-block;
    color: ${sharedPalette.watermelon};
    font-family: ${sansSerif};
    font-weight: bold;
  }

  .RecipeFirstRecipe__notesSection {
    border-top: 1px solid ${warmGrays[3]};
    padding: 1.25rem 1rem 0.25rem;
    font-family: ${sansSerif};
  }

  .RecipeFirstRecipe__notes a {
    color: black;
    text-decoration: underline;
  }

  .RecipeFirstRecipe__notesHeading {
    margin-bottom: 1rem;
  }

  .RecipeFirstRecipe__notes {
    font-size: var(--fontScale1);
    line-height: 1.5;
    font-size: calc(var(--baseFontSize) * 1.125);
  }

  .RecipeFirstRecipe h3,
  .RecipeFirstRecipe :global(.RecipeFirstRecipe__suppliesGroupName) {
    font-family: ${sansSerif};
    font-size: var(--baseFontSize);
    font-weight: bold;
    letter-spacing: 0.05em;
    text-transform: uppercase;
  }

  .RecipeFirstRecipe__ingredientsAddOn {
    margin-top: 2rem;
  }

  .RecipeFirstRecipe__instructionsHeading {
    padding-top: 2rem;
    padding-left: 1rem;
  }

  .RecipeFirstRecipe :global(.Recipe__instructionStep:first-of-type) {
    margin-top: 0;
    border-top: none;
    padding-top: 0;
  }

  .RecipeFirstRecipe__leftColumn {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .expandRecipeButton {
    display: none;
  }

  @media ${MQ_LARGE} {
    .RecipeFirstRecipe {
      display: flex;
      margin-top: 0;
      position: relative;
    }

    .RecipeFirstRecipe__leftColumn {
      height: fit-content;
      margin-right: 1rem;
    }

    .RecipeFirstRecipe__rightColumn {
      width: 100%;
      overflow: hidden;
    }

    .expandRecipeButton {
      display: block;
      position: absolute;
      bottom: 0;
      background: white;
      padding: 1rem;
      width: 100%;
      background: linear-gradient(
        180deg,
        rgba(245, 243, 243, 0.78) 0%,
        rgba(245, 243, 243, 1) 71%,
        rgba(245, 243, 243, 0.95) 100%
      );
    }

    .expandRecipeButton button {
      font-size: var(--fontScaleNeg1);
      font-weight: bold;
      color: #000;
      cursor: pointer;
      font-family: ${sansSerif};
      text-transform: uppercase;
      display: block;
      margin: auto;
      border: 0.15rem solid black;
      padding: 0.5rem 2rem;
      background: white;
    }

    .RecipeFirstRecipe h3,
    .RecipeFirstRecipe :global(.Recipe__ingredientsGroupName),
    .RecipeFirstRecipe :global(.Recipe__instructionsGroup h4),
    .RecipeFirstRecipe :global(.Recipe__suppliesGroupName) {
      margin-bottom: 1.75rem;
    }

    .RecipeFirstRecipe :global(.Recipe__instructionStep) {
      margin-top: 1.75rem;
      border-top: 1px solid ${warmGrays[1]};
      padding-top: 1.75rem;
      /* Interim size for recipe text alone */
      font-size: calc(var(--baseFontSize) * 1.125);
    }
  }
`;
